module.exports = "<div class=\"content\">\r\n  <ul class=\"nav nav-pills\" style=\"border-bottom:3px solid #3c8dbc;\">\r\n    <li ui-sref-active=\"active\" ng-repeat=\"material in $ctrl.product.materials\">\r\n      <a ui-sref=\"app.product.material({material:material.slug})\">\r\n        {{material.name}}\r\n      </a>\r\n    </li>\r\n  </ul>\r\n  <div ui-view>\r\n\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/modules/products/components/materials/template.html
 ** module id = 455
 ** module chunks = 0
 **/